import { Component, input, model } from '@angular/core';
import { TabOptions } from 'src/app/_models/tab-options';

@Component({
    selector: 'app-alt-option-tab-toggle',
    imports: [],
    templateUrl: './alt-option-tab-toggle.component.html',
    styleUrl: './alt-option-tab-toggle.component.scss'
})
export class AltOptionTabToggleComponent {
  title: 'AltOptionTabToggle';
  component: '';

 /** What value and text for each button (required) */
  groupName = input<string>();

  /** What value and text for each button (required) */
  selectOptions = input<TabOptions[]>();

  /** What type of button (optional, default: 'round') */
  type = input<'round' | 'square'>('round');

  /** Currently selected value (writable local signal) */
  currentValue = model<string>();

  /** ARIA label for the entire toggle group (optional) */
  ariaLabel = input<string>('');

  /** Description of the toggle's purpose for screen readers */
  ariaDescription = input<string>('');

  updateValue(value: string): void {
    this.currentValue.set(value);
  }
}